import React, { useState, useEffect } from "react";
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Avatar from 'react-avatar';
import { useKeycloak } from "@react-keycloak/web";

const Navigation = (props) => {
  const { keycloak } = useKeycloak();
  const [nifAdmin, setNifAdmin] = useState('');

  useEffect(() => {
    const stored = sessionStorage.getItem('nifAdmin');
    try {
      setNifAdmin(stored ? JSON.parse(stored) : '');
    } catch {
      setNifAdmin('');
    }
  }, []);

  function getSessionIsAdmin() {
    const stored = sessionStorage.getItem('ADM');
    try {
      return stored ? JSON.parse(stored) : false;
    } catch {
      return false;
    }
  }

  return (
    <div className="col-md-12 bg-white rounded-4 p-3 mb-4">
      <div className="text-center mb-3">
        <Avatar name={keycloak.tokenParsed.given_name + " " + keycloak.tokenParsed.family_name} color="#9DB1C9" size="80" round={true} />
        <p className="mt-3 mb-1" style={{ fontSize: '16px', fontWeight: '600' }}>{keycloak.tokenParsed.given_name + " " + keycloak.tokenParsed.family_name}</p>
        <p style={{ fontSize: '12px', color: '#3F5B78' }}>{sessionStorage.getItem('company')}</p>
      </div>
      {/* Pesquisa de novos utilizadores por NIF */}
      {getSessionIsAdmin() && (
        <div className="text-center mb-5">
          <label style={{ color: '#3F5B78', fontWeight: '600' }}>NIF utilizador</label>
          <input type="text" className="form-control" value={nifAdmin} onChange={(e) => {
            sessionStorage.setItem('nifAdmin', e.target.value);
            setNifAdmin(e.target.value);
          }} />
        </div>
      )}
      {/* Pesquisa de novos utilizadores por NIF - FIM */}
      <Nav className="nav navbar-nav sidebar" activeKey={props.activeKey}>
        <Navbar.Text>
          CARTEIRA
        </Navbar.Text>
        <Nav.Item>
          <Nav.Link href="/dashboard" className="mt-2">
            Dashboard
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link href="/extratoindividual" className="mt-2">
            Extrato individual
          </Nav.Link>
        </Nav.Item>
        <Nav.Item className="mb-5">
          <Nav.Link href="/extratoconsolidado" className="mt-2">
            Extrato consolidado
          </Nav.Link>
        </Nav.Item>
        <Navbar.Text>
          SUPORTE
        </Navbar.Text>
        <Nav.Item>
          <Nav.Link href="/pedidos" className="mt-2">
            Consultar pedidos
          </Nav.Link>
        </Nav.Item>
        <Nav.Item className="mb-5">
          <Nav.Link href="/registarpedido" className="mt-2">
            Registar pedido
          </Nav.Link>
        </Nav.Item>
        <Navbar.Text>
          OUTRAS OPÇÕES
        </Navbar.Text>
        <Nav.Item>
          <Nav.Link href="/dadospessoais" className="mt-2">
            Dados Pessoais
          </Nav.Link>
        </Nav.Item>
      </Nav>
    </div>
  );
};

export default Navigation;
